import { render, staticRenderFns } from "./ViewFilesModal.vue?vue&type=template&id=f4db8074&scoped=true"
import script from "./ViewFilesModal.vue?vue&type=script&lang=ts"
export * from "./ViewFilesModal.vue?vue&type=script&lang=ts"
import style0 from "./ViewFilesModal.vue?vue&type=style&index=0&id=f4db8074&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4db8074",
  null
  
)

export default component.exports